import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {DialogModule} from "primeng/dialog";
import {NgIf} from "@angular/common";
import {MakeService} from "../../../data/services/make.service";
import {Button} from "primeng/button";
import {MessagesModule} from "primeng/messages";
import {catchError, throwError} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";
import {MessageService} from "primeng/api";

@Component({
    selector: 'app-approve-all-makes-btn',
    standalone: true,
    imports: [
        DialogModule,
        NgIf,
        Button,
        MessagesModule
    ],
    templateUrl: './approve-all-makes-btn.component.html',
    styleUrl: './approve-all-makes-btn.component.css'
})
export class ApproveAllMakesBtnComponent {

    @Input({required: true}) dialogVisible!: boolean;

    @Output() onVisibilityChanged = new EventEmitter<boolean>();

    makeService = inject(MakeService);
    messageService = inject(MessageService);

    loading = false;
    failed = false;
    msgs = [{severity: 'error', detail: 'Failed to set image as approved for all makes'}]

    approve() {
        this.loading = true;
        this.failed = false;

        this.makeService.approveForAllMakes()
            ?.pipe(
                catchError((error) => this.handleError(error))
            ).subscribe(() => {
            this.loading = false;
            this.dialogVisible = false;
            this.onVisibilityChanged.emit(false);
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Successfully updated approved field'
            });
        })
    }

    handleError(error: HttpErrorResponse) {
        this.failed = true;
        this.loading = false;
        this.messageService.add({severity: 'error', summary: 'Error', detail: 'Failed to set image as approved for all makes'});
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }

    close() {
        this.onVisibilityChanged.emit(false);
        this.dialogVisible = false;
    }

}
